import { Box, styled } from 'decentraland-ui2'

export const SecondaryText = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  marginBottom: '32px',
  fontSize: '18px',
  flexWrap: 'wrap'
})
